var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbag6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17874 6.81333C7.17874 4.155 9.3373 2 12 2C14.6627 2 16.8213 4.155 16.8213 6.81333H19.9699C21.148 6.81333 22.0787 7.81122 21.9947 8.98439L21.2697 19.1177C21.1939 20.1783 20.3099 21 19.2449 21H4.75512C3.6901 21 2.80615 20.1783 2.73027 19.1177L2.00526 8.98439C1.92133 7.81122 2.85202 6.81333 4.03012 6.81333H7.17874ZM8.70125 6.81333H15.2988C15.2988 4.99448 13.8219 3.52 12 3.52C10.1782 3.52 8.70125 4.99448 8.70125 6.81333ZM6.92497 10.1067C6.50454 10.1067 6.16371 10.4469 6.16371 10.8667C6.16371 11.2864 6.50454 11.6267 6.92497 11.6267H14.7913V12.3867C14.7913 12.8064 15.1321 13.1467 15.5525 13.1467C15.973 13.1467 16.3138 12.8064 16.3138 12.3867V11.6267H17.075C17.4955 11.6267 17.8363 11.2864 17.8363 10.8667C17.8363 10.4469 17.4955 10.1067 17.075 10.1067H6.92497Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag6);
export default __webpack_public_path__ + "static/media/handbag-6.656397fe9e13a475ff0527b729109f85.svg";
export { ForwardRef as ReactComponent };